import { sleep } from 'root/apps/label/utils/async';

import { CFD_MESSAGES, HUB_MESSAGES, PRINTER_MESSAGES } from './types';

export const resolveOnTimeout = async <T>(
  promise: Promise<T>,
  timeout: number
): Promise<T | void> => {
  await Promise.race([sleep(timeout), promise]);
};

const EventToLoggerKeyMap = {
  HUB_MESSAGES: 'Hub',
  CFD_MESSAGES: 'CFD',
  PRINTER_MESSAGES: 'Printers',
};

export const getLoggerKeyFromEvent = (event: string) => {
  let loggerKey = '';
  if (Object.values(HUB_MESSAGES).includes(event as HUB_MESSAGES)) loggerKey = 'HUB_MESSAGES';
  else if (Object.values(CFD_MESSAGES).includes(event as CFD_MESSAGES)) loggerKey = 'CFD_MESSAGES';
  else if (Object.values(PRINTER_MESSAGES).includes(event as PRINTER_MESSAGES))
    loggerKey = 'PRINTER_MESSAGES';

  return EventToLoggerKeyMap[loggerKey as keyof typeof EventToLoggerKeyMap];
};
